// extracted by mini-css-extract-plugin
export default {"root":"hcx-financial-card-back-description_root__WGOeg"};